import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ReactImageFallback from "react-image-fallback";
import { ImageContainer, ImageView, FullScreenModal } from "./styles";
import defaultProductImage from "../../../assets/defaultImages/defaultUpdate.png";
import CustomButton from "../CustomButton/index.jsx";
import AWS from "aws-sdk";
import useImageProduct from "../../../hooks/useImageProduct.jsx";
import axios from "axios";
import { useMultipleEditionStore } from "../../../stores/useMultipleEditionStore.js";

const ImageVisor = ({ value, name, onToggle, toggleFullScreenModal }) => {
  const [isSmallModalOpen, setSmallModalOpen] = useState(false);
  const imageSrc = useImageProduct(value, 2000, 2000);

  const toggleSmallModal = () => {
    setSmallModalOpen((prev) => {
      const newState = !prev;
      if (onToggle) onToggle(newState);
      return newState;
    });
  };

  return (
    <>
      <ImageContainer onClick={toggleSmallModal}>
        <ReactImageFallback
          src={imageSrc}
          fallbackImage={defaultProductImage}
          alt={name ?? "Imagen del producto"}
        />
      </ImageContainer>

      {isSmallModalOpen && (
        <ImageView>
          <div className="header">
            <p>{name}</p>
            <div className="buttons">
              <CustomButton
                variant="gray"
                icon="fullscreen"
                onClick={() => toggleFullScreenModal(name, value)}
                iconOnly
                showTooltip
                tooltipText="Ver en pantalla completa"
              />
              <CustomButton
                variant="gray"
                icon="close"
                iconOnly
                onClick={toggleSmallModal}
              />
            </div>
          </div>
          <div className="body">
            <ReactImageFallback
              src={imageSrc}
              fallbackImage={defaultProductImage}
              alt={name ?? "Imagen del producto"}
            />
          </div>
        </ImageView>
      )}
    </>
  );
};

ImageVisor.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  onToggle: PropTypes.func,
  onChange: PropTypes.func,
};

ImageVisor.defaultProps = {
  value: "",
  name: "Imagen",
  onToggle: null,
};

export default ImageVisor;
